import { render, staticRenderFns } from "./SponsoredRecommendation.vue?vue&type=template&id=65dfd41b&scoped=true&"
import script from "./SponsoredRecommendation.vue?vue&type=script&lang=ts&"
export * from "./SponsoredRecommendation.vue?vue&type=script&lang=ts&"
import style0 from "./SponsoredRecommendation.vue?vue&type=style&index=0&id=65dfd41b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dfd41b",
  null
  
)

export default component.exports